
import { motion } from "framer-motion";

const SupportedExchanges = () => {
  const exchanges = [
    {
      name: "Bybit",
      logo: "/lovable-uploads/6fc24ac6-2aa2-4ced-813b-e82a03f81c81.png",
      referralLink: "https://partner.bybit.com/b/metrade"
    },
    {
      name: "Bitget",
      logo: "/lovable-uploads/bcc59b2b-7809-4083-bdaf-0655d6c55298.png",
      referralLink: "https://bonus.bitget.com/YLE6ZV"
    },
    {
      name: "OKX",
      logo: "/lovable-uploads/c832a6ee-a649-4b97-b88b-a9bd19ee01b0.png",
      referralLink: "https://www.okx.com/de/join/metrade"
    },
    {
      name: "Phemex",
      logo: "/lovable-uploads/65150818-855b-40d2-b7f4-d5469fcee9b2.png",
      referralLink: "https://phemex.com/promo/activity/competition/209?group=&referralCode=IVDDN8"
    }
  ];

  return (
    <section className="py-16 px-4 bg-corporate-white border-b border-corporate-neutral-25">
      <div className="container mx-auto">
        <motion.h2 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-xl md:text-2xl font-medium text-center mb-10 text-corporate-primary-75"
        >
          Supported exchanges, trusted by millions of people:
        </motion.h2>
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-wrap justify-center items-center gap-10 md:gap-16 lg:gap-24"
        >
          {exchanges.map((exchange, index) => (
            
            <motion.div 
              key={exchange.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 + 0.3 }}
              className="transition-all duration-300 hover:opacity-80 hover:-translate-y-1"
            ><a 
            href={exchange.referralLink} 
            target="_blank" 
            rel="noopener noreferrer"
          >
              <img
                src={exchange.logo}
                alt={`${exchange.name} logo`}
                width={140}
                height={50}
                className="h-10 md:h-12 w-auto object-contain"
              />
              </a>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default SupportedExchanges;
